import React, { FC } from 'react'
import { InlineWidget } from 'react-calendly'
import { ICalendly } from './type'

const Calendly: FC<ICalendly> = ({ url }) => {
  return <InlineWidget url={url} />
}

export default Calendly
